<template>
  <div v-if="sends.length">
    <div class="wg-kpd-head">
      <h2 class="wg-kpd-title">Past reports</h2>
    </div>
    <div class="wg-preports">
      <div v-for="send in sends" :key="send.id" class="wg-prep">
        <div class="pl">
          <div class="pt">{{ send.periodLabel }} report</div>
          <div class="ps">Sent {{ fmtDate(send.sentAt) }} to {{ send.recipients }}</div>
        </div>
        <button
          type="button"
          class="wg-pill outline sm"
          :disabled="openingId === send.id"
          @click="viewReport(send)"
        >
          {{ openingId === send.id ? 'Opening…' : 'View report' }}
        </button>
      </div>
      <div class="wg-prep-note">
        Past reports are snapshots of the email we sent. Their numbers never change, even if
        Google restates data later.
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Sent-report history (design_updated2 "Past reports"): one row per report
 * email actually sent. View report regenerates the PDF from the period's
 * immutable snapshot - identical bytes to what was emailed.
 */
import moment from 'moment'

export default {
  name: 'WinsPastReports',
  inject: ['wgToast'],
  props: {
    siteId: {
      type: Number,
      default: null,
    },
  },
  data () {
    return {
      sends: [],
      openingId: null,
    }
  },
  watch: {
    siteId: {
      handler () {
        this.load()
      },
      immediate: true,
    },
  },
  methods: {
    fmtDate (value) {
      return value ? moment(value).format('MMM D, YYYY') : '–'
    },
    load () {
      this.sends = []
      if (!this.siteId) return
      this.$store.dispatch('listWinsReportSends', this.siteId)
        .then((response) => {
          if (response.data && response.data.status === 'SUCCESS') {
            this.sends = response.data.sends || []
          }
        })
        .catch(() => {})
    },
    viewReport (send) {
      this.openingId = send.id
      this.$store.dispatch('getWinsReportPdf', { siteId: this.siteId, period: send.periodKey })
        .then((response) => {
          const url = URL.createObjectURL(
            new Blob([response.data], { type: 'application/pdf' }))
          window.open(url, '_blank')
          setTimeout(() => URL.revokeObjectURL(url), 60000)
        })
        .catch(() => {
          this.wgToast('Could not open the report', null, 'error')
        })
        .finally(() => {
          this.openingId = null
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../Settings/settings-card.scss';

.wg-kpd-head {
  display: flex;
  align-items: baseline;
  gap: 14px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.wg-kpd-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: $pop-teal;
  margin: 0;
}

/* past reports - snapshots of what was emailed (design_updated2) */
.wg-preports {
  background: #fff;
  border: 1px solid $wg-panel-line;
  border-radius: 12px;
  padding: 6px 20px;
  margin-bottom: 30px;
}

.wg-prep {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 13px 0;
  border-bottom: 1px solid $wg-hairline;

  .pl {
    flex: 1;
    min-width: 0;
  }

  .pt {
    font-size: 0.9rem;
    font-weight: 700;
    color: $pop-teal;
  }

  .ps {
    font-size: 0.78rem;
    color: $pop-ink-faint;
    margin-top: 2px;
  }
}

.wg-prep .wg-pill {
  text-decoration: underline;
}

.wg-prep-note {
  font-size: 0.78rem;
  color: $pop-ink-faint;
  padding: 12px 0;
}
</style>
